import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import Avatar from "@material-ui/core/Avatar";
import LockIcon from "@material-ui/icons/Lock";
import {makeStyles, useTheme} from "@material-ui/core/styles";

const LoginButton = () => {

    let theme = useTheme();
    const classes = makeStyles({
        avatar: {
            backgroundColor: theme.palette.secondary.main,
        },
    })();

    const { loginWithRedirect } = useAuth0();
    return (
        <Avatar className={classes.avatar}>
            <LockIcon onClick={() => loginWithRedirect()}/>
        </Avatar>
    );
};

export default LoginButton;